import { Box, Typography, Chip } from '@mui/material';

interface TagInfo {
  number?: string;
  info?: {
    material?: string;
    color?: string;
    profile?: string;
    weight?: number;
  };
}

interface MaterialChangedTagDisplayProps {
  tag: TagInfo;
  label: string;
}

export const MaterialChangedTagDisplay = ({ tag, label }: MaterialChangedTagDisplayProps) => {
  const tagNumber = tag?.number || 'unknown';
  const info = tag?.info;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary' }}>
        {label}
      </Typography>
      <Chip
        label={`Tag: ${tagNumber}`}
        size="small"
        color={tagNumber === 'unknown' ? 'default' : 'primary'}
        sx={{ alignSelf: 'flex-start' }}
      />
      {info && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
          {info.material && (
            <Typography variant="body2">
              <strong>Material:</strong> {info.material}
            </Typography>
          )}
          {info.color && (
            <Typography variant="body2">
              <strong>Color:</strong> {info.color}
            </Typography>
          )}
          {info.profile && (
            <Typography variant="body2">
              <strong>Profile:</strong> {info.profile}
            </Typography>
          )}
          {info.weight && (
            <Typography variant="body2">
              <strong>Weight:</strong> {info.weight} g
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
